import empDeductionsReducer from "./reducers";
export { default as empDeductionsTypes } from "./types";
export { default as empDeductionsActions } from "./actions";
export { default as empDeductionsOperations } from "./operations";
export default empDeductionsReducer;
